import { Alert, Box, Grid, Typography, lighten } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Colors } from 'src/shared/components/styles/colors';
import { DateHelper } from 'src/shared/helpers/dateHelper';

type GroupMessageIsDeletedStatusMessageProps = {
  deletedAt: string;
  deletedBy: string;
};

export const GroupMessageIsDeletedStatusMessage = (props: GroupMessageIsDeletedStatusMessageProps) => {
  const { deletedAt, deletedBy } = props;
  const { t } = useTranslation();

  return (
    <Grid item xs={12}>
      <Alert
        severity='warning'
        variant='outlined'
        icon={false}
        sx={{ backgroundColor: lighten(Colors.ChipColors.Yellow, 0.9), '& .MuiAlert-message': { width: '100%' } }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
          <Typography variant='body1' sx={{ m: 0 }}>
            <strong>{t('groupMessage:edit.deletedBy')}</strong> {deletedBy}
          </Typography>
          <Typography variant='body1' sx={{ m: 0 }}>
            <strong>{t('groupMessage:edit.deletedAt')}</strong> {DateHelper.getDateTime(deletedAt)}
          </Typography>
        </Box>
      </Alert>
    </Grid>
  );
};
